// @flow strict

// $FlowFixMe[untyped-import] this has a guaranteed structure when generated
import tzNames from 'src/components/lib/tz/tznames.json';
import {customTimezones, excludedTimezones} from './constants.js';


export const isValidTimezone = (timezone: string): boolean => {
  const timezoneKeys = [
    ...Object.keys(tzNames),
    ...Object.keys(customTimezones),
  ];
  const filteredTimezoneKeys = timezoneKeys.filter(
    (key) => !excludedTimezones.includes(key),
  );

  return filteredTimezoneKeys.includes(timezone);
};
